import React, { createContext, useState, useContext } from 'react';

const GPTDataContext = createContext({
    message: "",
    username: "",
    isAITyping: false,
    conversation: [{ role: "assistant", content: "Hello! Welcome to CytoHub. How can I assist you today?" }], // Initial conversation

    setMessage: () => {},
    setUsername: () => {},
    setIsAITyping: () => {},
    setConversation: () => {},
  });
  
  export const GPTDataProvider = ({ children }) => {
    const [message, setMessage] = useState("");
    const [username, setUsername] = useState("");
    const [isAITyping, setIsAITyping] = useState(false);
    const [conversation, setConversation] = useState([{ role: "assistant", content: "Hello! Welcome to CytoHub. How can I assist you today?" }]);
  
    return (
      <GPTDataContext.Provider
        value={{message, username, isAITyping, conversation,
          setMessage, setUsername, setIsAITyping, setConversation,
        }} >
        {children}
      </GPTDataContext.Provider>
    );
  };
  
  export const useGPTData = () => useContext(GPTDataContext);